//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import { translate } from "react-i18next";
import DefaultButton from './../../components/DefaultButton';
import GhostButton from './../../components/GhostButton';
import TextInput from './../../components/TextInput';
import MainPageContainer from '../../components/MainPageContainer';
import PoweredInfo from './../../components/PoweredInfo';
import { RECAPTCHA_SITE_KEY } from './../../config';
import {
    AXIOS_INSTANCE,
} from './../../types/auth';
import { signOut } from './../../actions/auth';
import loading from './../../utilities/loading';
import messageManager from './../../utilities/messageManager';

const FormTitle = styled.p`
    margin: 5px 20px;
    width: 300px;
`;
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    width: calc(100% - 40px);
    margin: 15px;
`;
const FlexForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const PInfoWrapper = styled.div`
    width: calc(100% - 20px);
`;

type State = {
    email: string,
    recaptchaResponse: string,
    sendButtonDisabled: boolean,
};

type Props = {
    axiosInstance: any,
    t: (text: string) => {},
}

export class SignIn extends React.Component<Props, State> {
    constructor(): void {
        super();

        this.state = {
            email: '',
            recaptchaResponse: '',
            sendButtonDisabled: false,
        };
    }

    handleSubmit() {
        const { BASE_URL, axiosInstance, type, t } = this.props;
        const { email, recaptchaResponse }: State = this.state;

        loading.start();
        this.setState({ sendButtonDisabled: true })

        let ENDPOINT_URL
        if (type === 'lost' || type === 'expired') ENDPOINT_URL = 'resend-activation-link';
        if (type === 'forgot') ENDPOINT_URL = 'forgot-password';

        axiosInstance.post(`${BASE_URL}account/${ENDPOINT_URL}`, {
            login: email,
            recaptchaResponse: recaptchaResponse
        })
            .then((response) => {
                messageManager.show({
                    type: 'info',
                    text: t('Link has been sent'),
                })

                loading.stop();
                this.setState({ sendButtonDisabled: false })
                window.grecaptcha.reset();
            })
            .catch((error) => {
                messageManager.show({
                    text: t(error.response.data),
                    type: 'error',
                })
                loading.stop();
                this.setState({ sendButtonDisabled: false })
                window.grecaptcha.reset();
            })
    }

    render(): React.Node {
        const { email, sendButtonDisabled }: State = this.state;
        const { t, type }: Props = this.props;
        let MESSAGE;
        switch(type) {
            case 'lost':
                MESSAGE = t('If you lost your activation link');
                break;
            case 'forgot':
                MESSAGE = t('If you forgot your password');
                break;
            case 'expired':
                MESSAGE = t('Your activation link has expired');
                break;
            default:
                MESSAGE = t('If you lost your activation link');
        }
        return (
            <MainPageContainer>
                <FlexForm onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleSubmit();
                }}>
                    <input type="submit" value="Submit" style={{ display: 'none' }} />
                    <FormTitle
                        style={{ marginBottom: '0' }}>
                        {MESSAGE}
                    </FormTitle>
                    { type !== 'expired' &&
                        <FormTitle
                            style={{ textTransform: 'lowercase', marginTop: '0' }}>
                            {t('Enter email associated with your account')}:
                        </FormTitle>
                    }
                    <TextInput
                        style={{
                            width: '290px',
                            margin: '5px 0 10px 0',
                            fontSize: '14px',
                        }}
                        type="email"
                        placeholder="example@mail.com"
                        autoComplete="email"
                        required
                        name="email"
                        value={email}
                        tip={t("We'll send you a mail with link to reset your password") + "."}
                        onChange={event => {
                            this.setState({ email: event.target.value });
                        }} />
                    <ReCAPTCHA
                        ref="recaptcha"
                        sitekey={RECAPTCHA_SITE_KEY}
                        onChange={(resposne) => { this.setState({ recaptchaResponse: resposne }) }}
                    />

                    <ButtonWrapper>
                        <GhostButton
                            onClick={() => {
                                this.props.signOut();
                                window.location.replace('./#/signin')
                            }}
                            style={{
                                height: '25px',
                                width: '50px',
                                display: 'flex',
                                marginRight: '5px',
                            }}>
                            {`${t('Back')}`}
                        </GhostButton>

                        <DefaultButton
                            style={{
                                width: '58px',
                                marginLeft: '5px',
                            }}
                            disabled={sendButtonDisabled}
                            onClick={(e) => {
                                this.handleSubmit();
                            }}>
                            {t('Send')}
                        </DefaultButton>
                    </ButtonWrapper>
                </FlexForm>
                {type === 'expired' && <PInfoWrapper><PoweredInfo /></PInfoWrapper>}
            </MainPageContainer >
        );
    }
};

const mapStateToProps = state => ({
    [AXIOS_INSTANCE]: state.auth.get(AXIOS_INSTANCE),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    signOut
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(SignIn));


// WEBPACK FOOTER //
// ./src/containers/forgotPassword/ForgotPassword.jsx